import { Injectable } from '@angular/core';
import { TranslationService } from '@proximus/ng-common';

@Injectable({
  providedIn: 'root',
})
export class BrandService {
  constructor(private translationService: TranslationService) {}

  getAppBrandValue() {
    return this.translationService.getTranslatedValueFor('app.brand');
  }

  isScarlet() {
    return this.getAppBrandValue() === 'scarlet';
  }
}
